import React from "react";

import Button from "./Button";
import { ButtonPropTypes } from "./buttonPropsTypes";
import injectStores from "../RootStore/injectStores";
import { RouterStore } from "stores/RouterStore";
import { RouteParamsType, RouteQueryParamsType } from "types/RouteType";

interface RouteButtonProps extends ButtonPropTypes {
  routeName?: string;
  routeParams?: RouteParamsType;
  routeQueryParams?: RouteQueryParamsType;
  routerStore?: RouterStore;
  loading?: boolean;
  keepParams?: boolean;
  // Add other props from buttonPropTypes here
}
class RouteButtonComponent extends React.PureComponent<RouteButtonProps> {
  static defaultProps = {
    disabled: false,
    color: "gray" as const,
    simple: false,
    round: false,
    fullWidth: false,
    block: false,
    link: false,
    justIcon: false,
  };

  render() {
    const {
      routeName,
      routeParams,
      routeQueryParams,
      routerStore,
      children,
      tooltip,
      disabled,
      justIcon,
      size,
      autosize,
      autosizeIcon,
      color,
      round,
      fullWidth,
      loading,
      keepParams,
    } = this.props;
    if (!routeName && !routeParams && !routeQueryParams) {
      console.error(
        "Requires at least one of: routeName, routeParams, routeQueryParams"
      );
      return null;
    }
    let nextRouteParams = routeParams;
    if (keepParams && routerStore) {
      nextRouteParams = routerStore.params;
    }

    return (
      <Button
        disabled={disabled}
        justIcon={justIcon}
        size={size}
        autosize={autosize}
        autosizeIcon={autosizeIcon}
        color={color}
        round={round}
        fullWidth={fullWidth}
        loading={loading}
        tooltip={tooltip}
        onClick={() => {
          if (!routerStore) return;
          const nextRoute = routeName
            ? routeName.replaceAll(" ", "")
            : routerStore.currentRoute;
          routerStore.goTo(nextRoute, nextRouteParams, routeQueryParams);
        }}
      >
        {children}
      </Button>
    );
  }
}

const RouteButton = injectStores(RouteButtonComponent);

export { RouteButton };
export default RouteButton;
